import Breadcrumbs from '@/components/Breadcrumbs';
import useTopbar from '@hooks/useTopbar';

/**
 * The page has no content of its own yet, so this only puts the breadcrumbs in
 * the header — the one thing every page does. Whatever Home grows into hangs
 * off here.
 */
const useHomePage = () => {
	useTopbar(<Breadcrumbs />);
};

export default useHomePage;
